import React, { Suspense } from 'react'
import Card from '../../../../../../components/Card'
import Body from './Body'
import List from './List'
import { faPencil, faTrash } from '@fortawesome/free-solid-svg-icons'
import EditModel from './EditModal'
import useToggleState from 'src/hooks/useToggleState'
import DeleteModal from 'src/pages/cat/distributions/Distribution/cards/Details/DeleteModel'

interface DetailsProps {
  id: string
}

const Details: React.FC<DetailsProps> = (props) => {
  const { id } = props
  const [isOpen, , handleToggle] = useToggleState()
  const [isDeleteOpen, , handleDeleteToggle] = useToggleState()

  return (
    <>
      <Card
        title='Distribution'
        primaryAction={{
          key: 'edit',
          icon: faPencil,
          onClick: handleToggle,
          permissionKey: 'CAT_EDIT'
        }}
        secondaryActions={[{
          key: 'delete-candidate',
          onClick: handleDeleteToggle,
          icon: faTrash,
          text: 'Delete',
          permissionKey: 'CAT_EDIT',
          iconProps: {
            className: 'text-danger'
          }
        }]}
      >
        <Suspense fallback={<List distribution={undefined} />}>
          <Body id={id} />
        </Suspense>
      </Card>
      <EditModel id={id} isOpen={isOpen} toggle={handleToggle} />
      <DeleteModal id={id} isOpen={isDeleteOpen} toggle={handleDeleteToggle} />
    </>
  )
}

export default Details
